// extracted by mini-css-extract-plugin
export default {"Header":"Samples_Header__2aP9d","Input":"Samples_Input__yOUB8"};